/**
 * CardContainerControl
 * Groups child controls inside a labelled card/section.
 */

import React, { memo } from 'react';
import type { FormControl } from '@atlas-forms/types-js';

export interface CardContainerControlProps {
  control: FormControl & { children?: FormControl[] };
  renderChild: (child: FormControl) => React.ReactNode;
}

export const CardContainerControl = memo(function CardContainerControl({ control, renderChild }: CardContainerControlProps) {
  const children = control.children ?? [];

  return (
    <fieldset className="card-container-control" data-control-id={control.id}>
      {control.label && (
        <legend className="card-container-control__title">{control.label}</legend>
      )}
      {children.map((child) => (
        <React.Fragment key={child.id}>{renderChild(child)}</React.Fragment>
      ))}
    </fieldset>
  );
});
